import Enums from 'utils/EnumsManager';

const { INVOICE } = Enums.REDUX_ACTION_TYPE_PREFIX;
const SUMMARY = 'SUMMARY';
export const ACTIVATE_ROW = `${INVOICE}_${SUMMARY}_ACTIVATE_ROW`;
export const DEACTIVATE_ROW = `${INVOICE}_${SUMMARY}_DEACTIVATE_ROW`;
export const SET_ROW_VALUE = `${INVOICE}_${SUMMARY}_SET_ROW_VALUE`;
export const SET_SUMMARY = `${INVOICE}_${SUMMARY}_SET_SUMMARY`;



// WEBPACK FOOTER //
// ./src/views/Invoice/flow/summary/actionTypes.js